import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SG_TEMPLATE_VERIFY } from 'constants/actions';
import { useParams } from 'react-router-dom';

export default function Verify() {
  const dispatch = useDispatch();
  const verifyResult = useSelector((s) => s.action_template?.verifyResult);
  const { id } = useParams();

  useEffect(() => {
    if (id) dispatch({ type: SG_TEMPLATE_VERIFY, payload: { id } });
  }, [dispatch, id]);

  return (
    <div>
      <h2>Verify Template #{id}</h2>
      <pre>{verifyResult ? JSON.stringify(verifyResult, null, 2) : 'Running...'}</pre>
    </div>
  );
}
